import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Inyectar tracking scripts dinámicamente
const injectTrackingScripts = () => {
  // Solo ejecutar en el navegador
  if (typeof window === 'undefined') return;

  // Obtener IDs desde variables de entorno (configuradas en Netlify)
  const googleId = (process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '').trim();
  const hotjarIdRaw = (process.env.REACT_APP_HOTJAR_ID || '').trim();
  const hotjarIdNum = parseInt(hotjarIdRaw, 10);

  if (googleId && !/^G-?X{6,}$/i.test(googleId)) {
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${googleId}`;
    document.head.appendChild(gtagScript);

    const gtagConfig = document.createElement('script');
    gtagConfig.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${googleId}');
    `;
    document.head.appendChild(gtagConfig);
  }

  // Crear e inyectar Hotjar
  if (Number.isFinite(hotjarIdNum) && hotjarIdNum > 0) {
    const hotjarScript = document.createElement('script');
    hotjarScript.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${hotjarIdNum},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    document.head.appendChild(hotjarScript);
  }
};

// Inyectar scripts cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectTrackingScripts);
} else {
  injectTrackingScripts();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 